module.exports = __webpack_public_path__ + "media/up.86dddb68.ogg";